<script>
import lucra from '@/mixins/lucra'
import messages from '@/mixins/messages'
import { getLucraClient } from '@/util/lucra/client'

export default {
    name: 'CashWallet',
    mixins: [lucra, messages],
    data() {
        return {
            busy: false,
            connected: false,
            balance: null,
            accountStatus: null,
        }
    },
    computed: {
        balanceLabel() {
            return this.balance != null ? '$' + Number(this.balance).toFixed(2) : null
        },
        verified() {
            return this.accountStatus === 'VERIFIED'
        },
        statusLabel() {
            if (!this.accountStatus) {
                return null
            }
            return this.verified ? 'Verified' : 'Verification pending'
        },
    },
    methods: {
        applyUser(user) {
            this.connected = true
            if (user && typeof user.balance === 'number') {
                this.balance = user.balance
            }
            if (user && user.accountStatus) {
                this.accountStatus = user.accountStatus
            }
        },
        async openRoute(route) {
            if (this.busy) {
                return
            }
            this.busy = true
            try {
                await this.$lucraLinkUser()
                const balanceBefore = this.balance
                const user = await this.$lucraOpenRoute(this.$refs.container, route)
                this.applyUser(user)
                if (user && typeof user.balance === 'number' && balanceBefore != null && user.balance !== balanceBefore) {
                    const change = Math.abs(user.balance - balanceBefore).toFixed(2)
                    this.addMessage('success', user.balance > balanceBefore ? `$${change} was added. Your balance is now $${user.balance.toFixed(2)}.` : `Your balance is now $${user.balance.toFixed(2)}.`)
                }
            } catch (e) {
                this.addMessage('danger', 'The cash wallet did not open: ' + (e && e.message ? e.message : 'try again in a moment') + '.')
            }
            this.busy = false
        },
    },
    async mounted() {
        try {
            const client = await getLucraClient()
            if (client && client.user) {
                this.applyUser(client.user)
            }
        } catch (e) {
            // Wallet stays in its "open to connect" state.
        }
    },
    async beforeDestroy() {
        await this.$lucraCloseRoute()
    },
}
</script>

<template>
    <div class="cashwallet">
        <messages />
        <div class="d-flex align-items-start justify-content-between">
            <div>
                <div class="cashwallet__balance" v-if="balanceLabel">{{ balanceLabel }}</div>
                <div class="text-muted small mt-1" v-else>Öffne deine Wallet, um Guthaben einzuzahlen, abzuheben und deinen Kontostand anzuzeigen.</div>
            </div>
            <b-badge :variant="verified ? 'success' : 'light'" v-if="statusLabel">{{ statusLabel }}</b-badge>
        </div>
        <div class="d-flex flex-wrap cashwallet__actions mt-3">
            <b-button variant="primary" :disabled="busy" @click="openRoute('wallet')">
                <b-spinner small v-if="busy" /> {{ connected ? 'Wallet verwalten' : 'Cash-Wallet öffnen' }}
            </b-button>
        </div>
        <div ref="container" class="cashwallet__lucra"></div>
    </div>
</template>

<style lang="scss" scoped>
.cashwallet__balance {
    font-size: 26px;
    font-weight: 600;
    color: var(--text-heading);
    margin-top: 4px;
}
.cashwallet__actions {
    gap: 10px;
}
.cashwallet__lucra {
    position: fixed;
    inset: 0;
    z-index: 3000;
}
.cashwallet__lucra:empty {
    display: none;
}
</style>
